import MarketingDashboardView from "./MarketingDashboardView";

export default function MarketingDashboardPage() {
  return <MarketingDashboardView />;
}
